<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> 监测信息
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <el-container>
        <el-main>
            <el-row :gutter="12">
                <el-col :span="8">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span class="sphead">运销监测</span>
                        </div>
                        <el-card shadow="hover" style="margin-bottom: 10px">
                            <div class="user-info-list odd">
                                <div :class="[testConnect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">当日销量(t)</div>
                                <div :class="[testConnect == '连接成功' ? 'contentrightYes' : 'contentrightNo']">{{this.TransportSalesDay}}</div>
                            </div>
                            <div class="user-info-list">
                                <div :class="[testConnect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">当月销量(t)</div>
                                <div :class="[testConnect == '连接成功' ? 'contentrightYes' : 'contentrightNo']">{{this.TransportSalesMonth}}</div>
                            </div>
                            <div class="user-info-list odd">
                                <div :class="[testConnect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">库存(t)</div>
                                <div :class="[testConnect == '连接成功' ? 'contentrightYes' : 'contentrightNo']">0.00</div>
                            </div>
                        </el-card>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span class="sphead">电力监测</span>
                            <el-radio-group v-model="radioTreaty" @change="radioChange">
                                <el-radio label="1" style="margin-left:80px">实时总电量</el-radio>
                                <el-radio label="2" style="margin-left:10px">当日电量</el-radio>
                            </el-radio-group>
                        </div>
                        <el-card v-show="radioFlag" shadow="hover" style="margin-bottom: 10px">
                            <div class="user-info-list odd">
                                <div :class="[testConnect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">煤矿总关口(kwh)</div>
                                <div :class="[testConnect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" style="margin-right:-90px">{{this.mineTotalElectricitySum}}</div>
                            </div>
                            <div class="user-info-list">
                                <div :class="[testConnect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">井下供电关口(kwh)</div>
                                <div :class="[testConnect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" style="margin-right:-90px">{{this.downholeElectricitySum}}</div>
                            </div>
                            <div class="user-info-list odd">
                                <div :class="[testConnect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">主运输设备供电关口(kwh)</div>
                                <div :class="[testConnect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" style="margin-right:-90px">{{this.transportElectricitySum}}</div>
                            </div>
                        </el-card>
                        <el-card v-show="!radioFlag" shadow="hover" style="margin-bottom: 10px">
                            <div class="user-info-list odd">
                                <div :class="[testConnect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">煤矿总关口(kwh)</div>
                                <div :class="[testConnect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" style="margin-right:-90px">{{ this.mineTotalElectricityDay }}</div>
                            </div>
                            <div class="user-info-list">
                                <div :class="[testConnect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">井下供电关口(kwh)</div>
                                <div :class="[testConnect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" style="margin-right:-90px">{{ this.downholeElectricityDay }}</div>
                            </div>
                            <div class="user-info-list odd">
                                <div :class="[testConnect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">主运输设备供电关口(kwh)</div>
                                <div :class="[testConnect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" style="margin-right:-90px">{{ this.transportElectricityDay }}</div>
                            </div>
                        </el-card>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span class="sphead">电机监测</span>
                            <el-select v-model="motor" class="size-full" style="margin-left:100px" ref="selectMotor" @change="selectMotor()" clearable>
                                <el-option v-for="item in motors" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <el-card shadow="hover" style="margin-bottom: 10px">
                            <div class="user-info-list odd">
                                <div :class="[connect == 'connect' ? 'titleleftYes' : 'titleleftNo']">温度(℃)</div>
                                <div :class="[connect == 'connect' ? 'contentrightYes' : 'contentrightNo']">{{this.temp}}</div>
                            </div>
                            <div class="user-info-list">
                                <div :class="[connect == 'connect' ? 'titleleftYes' : 'titleleftNo']">&nbsp; </div>
                                <div :class="[connect == 'connect' ? 'contentrightYes' : 'contentrightNo']">&nbsp; </div>
                            </div>
                            <div class="user-info-list odd">
                                <div :class="[connect == 'connect' ? 'titleleftYes' : 'titleleftNo']">震动(mm/s)</div>
                                <div :class="[connect == 'connect' ? 'contentrightYes' : 'contentrightNo']">{{this.vibrationFrequency}}</div>
                            </div>
                        </el-card>
                    </el-card>
                </el-col>
            </el-row>
        </el-main>
    </el-container>
</div>
</template>

<script>
import {
    SortField
} from '../../utils/helper';
export default {
    name: 'motor',
    data: function () {
        return {
            // electricitySum: '',
            // electricityDay: '',
            mineTotalElectricityDay:'',
            downholeElectricityDay:'',
            transportElectricityDay:'',
            mineTotalElectricitySum:'',
            downholeElectricitySum:'',
            transportElectricitySum:'',

            TransportSalesDay:'',
            TransportSalesMonth:'',
            motor: '',
            motors: {},
            testConnect: "连接成功",
            connect: '',
            temp: '0.0',
            vibrationFrequency: '0.0',
            radioTreaty: '1',
            radioFlag: true,
            query: {
                Field1: '',
                Field2: '',
                PageIndex: 1,
                PageSize: 15
            },
        };
    },
    created() {
        this.getData();
        this.getRealTimeData();
        this.selectMotor();
        this.getElectricPoweData();
        this.getTransportSalesData();
    },
    mounted: function () {
        if (this.timer) {
            clearInterval(this.timer);
        } else {
            this.timer = setInterval(() => {
                this.getRealTimeData();
                this.getElectricPoweData();
                this.getTransportSalesData();
            }, 1000 * 6)
        }
    },
    destroyed() {
        clearInterval(this.timer);
    },
    methods: {
        radioChange: function (val) {
            this.radioFlag = ((val === '1') ? true : false);
        },
        getData() {
            this.$zybhttp
                .post('Motor/GetList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        newdata = newdata.map((x) => {
                            //console.log(x);
                            x.isUseFt = x.isUse == '1';
                            return x;
                        }, []);
                        this.motors = newdata;
                        this.motor = newdata[0].name;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getRealTimeData() {
            this.$zybhttp
                .get('Motor/GetMotorMonitorRealTimeData', {})
                .then((res) => {
                    this.motor = this.$refs.selectMotor.selectedLabel;
                    if (res.data.status == 0) {
                        var data = res.data.data.list;
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].MotorName == this.motor) {
                                this.temp = data[i].temp;
                                this.vibrationFrequency = data[i].vibrationFrequency;
                                this.connect = data[i].connect
                            }
                        }
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        selectMotor() {
            this.getRealTimeData();
        },
        getElectricPoweData() {
            this.$zybhttp
                .post('ProdInquiry/ElectricPoweData')
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.logRecords = d;
                        // this.electricitySum = res.data.msg;
                        // this.electricityDay = res.data.info1;
                        this.mineTotalElectricityDay = res.data.info1;
                        this.downholeElectricityDay = res.data.info2;
                        this.transportElectricityDay = res.data.info3;
                        this.mineTotalElectricitySum = res.data.info4;
                        this.downholeElectricitySum = res.data.info5;
                        this.transportElectricitySum = res.data.info6;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getTransportSalesData() {
            this.$zybhttp
                .post('ProdInquiry/TransportSalesData')
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.logRecords = d;
                        this.TransportSalesMonth = res.data.msg;
                        this.TransportSalesDay = res.data.info1;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
    }
};
</script>

<style scoped>
.divA {
    float: left;
    width: 30%;
    /* border: 1px solid #fbacce; */
}

.divB {
    float: left;
    width: 48%;
    /* border: 1px solid #fbacce; */
    margin-left: 30px;
}

.divB div,
h3 {
    margin-bottom: 30px;
}

.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both
}

.box-card {
    width: 480px;
}

.user-info-list {
    font-size: 18px;
    color: #999;
    line-height: 30px;
    display: -webkit-flex;
}

.odd {
    background: rgb(241, 239, 239);
    border-radius: 0.3rem;
}

.contentrightNo {
    width: 60%;
    color: crimson;
    font-weight: bold;
    font-family: 微软雅黑;
}

.contentrightYes {
    width: 60%;
    font-weight: bold;
    color: #1a8e83;
    font-family: 微软雅黑;
}

.titleleftNo {
    width: 40%;
    padding-left: 0.5rem;
    color: crimson;
    font-weight: bold;
    font-family: 微软雅黑;
}

.titleleftYes {
    width: 60%;
    padding-left: 0.5rem;
    color: #1a8e83;
    font-weight: bold;
    font-family: 微软雅黑;
}

.sphead {
    font-size: 25px;
    color: #e56230;
    font-family: cursive;
    font-weight: bold;
}

.size-full {
    width: 50%;
}
</style>
